// src/pages/GoogleMyBusiness.js
import React from 'react';
import FeaturePageLayout from '../components/FeaturePageLayout';
import { 
    IoBusinessOutline,
    IoLocationOutline,
    IoStarOutline,
    IoChatboxOutline,
    IoAnalyticsOutline
} from 'react-icons/io5';
import image1 from '../assets/images/Generate.png';
import image2 from '../assets/images/Schedule2.png';
import image3 from '../assets/images/Messages.png';
import image4 from '../assets/images/Analytics2.png';
import heroBg from '../assets/images/google-my-business-background.png';

const breadcrumbSchema = { "@context": "https://schema.org", "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://oolook.in/" }, { "@type": "ListItem", "position": 2, "name": "Google Business Profile Management", "item": "https://oolook.in/google-my-business" }] };
const serviceSchema = { "@context": "https://schema.org", "@type": "Service", "serviceType": "Local SEO Software", "provider": { "@type": "Organization", "name": "Oolook" }, "name": "AI Google Business Profile Management Tool", "description": "Optimize your Google Business Profile with Oolook. Use AI to create and schedule posts, manage reviews, and track your local search performance.", "url": "https://oolook.in/google-my-business" };

const pageData = {
  seo: {
    title: "Google Business Profile Management Tool | Oolook",
    description: "Boost your local SEO. Oolook helps you manage your Google Business Profile by scheduling posts, responding to reviews with AI, and tracking your local search ranking.",
    image: 'https://oolook.in/og/gmb.png',
    schemas: [breadcrumbSchema, serviceSchema]
  },
  hero: {
    icon: IoBusinessOutline,
    title: "Dominate Local Search",
    subtitle: "Turn your Google Business Profile into your most powerful customer acquisition tool. Oolook helps you optimize your listing, engage with customers, and attract more foot traffic.",
    backgroundImage: heroBg
  },
  featureSection: {
    title: "A Complete Toolkit for Your Local Presence",
    subtitle: "Manage every aspect of your Google Business Profile to rank higher and convert more local customers.",
    features: [
      { title: "AI Post & Update Generator", description: "Keep your profile fresh with AI-generated posts about your offers, events, and news, optimized for local search.", image: image1 },
      { title: "Schedule Profile Updates", description: "Plan and schedule your Google Posts in advance to maintain an active and engaging local presence effortlessly.", image: image2 },
      { title: "Manage Reviews & Questions", description: "Monitor and respond to all your Google reviews and questions from our Unified Inbox, with AI-assisted replies.", image: image3 },
      { title: "Track Local SEO Performance", description: "Analyze how customers find you, what actions they take on your listing, and how your ranking is improving over time.", image: image4 }
    ]
  },
  benefitGrid: {
    title: "The Impact of a Perfectly Optimized Profile",
    benefits: [
      { icon: IoLocationOutline, title: "Attract More Customers", description: "Rank higher in local search results and Google Maps to drive more calls, website visits, and foot traffic." },
      { icon: IoStarOutline, title: "Build Trust with Reviews", description: "Improve your reputation and build social proof by responding to customer reviews quickly and professionally." },
      { icon: IoChatboxOutline, title: "Engage Your Community", description: "Keep your local audience informed and engaged with timely posts about what's new at your business." },
      { icon: IoAnalyticsOutline, title: "Understand Local Search", description: "Make data-driven decisions to improve your visibility based on how local customers are finding you." }
    ]
  },
  stepByStep: {
    title: "Master Your Local Marketing in Minutes",
    subtitle: "A simple workflow for optimizing your Google Business Profile.",
    steps: [
      { title: "1. Connect Your Business Profile", description: "Securely link your Google Business Profile to Oolook to get started." },
      { title: "2. Schedule Your First Google Post", description: "Use the AI generator to create a post about a current promotion and schedule it to your content calendar." },
      { title: "3. Set Up Review Replies", description: "Configure AI-assisted replies to quickly respond to new customer reviews as they come in." },
      { title: "4. Monitor Your Local Rank", description: "Check your analytics dashboard to track key local SEO metrics like search views, map views, and customer actions." }
    ]
  },
  targetAudience: {
    title: "The Essential Tool for Local Businesses and Franchisees"
  }
};

const GoogleMyBusiness = () => {
  return <FeaturePageLayout pageData={pageData} />;
};

export default GoogleMyBusiness;